const INITIAL_VALUE = {
  FUNCTION: () => {},
  OBJECT: {},
  ARRAY: [],
  STRING: '',
};

export default INITIAL_VALUE;
